module.exports = __webpack_public_path__ + "static/img/nodata-medelwall.6a5524d2.png";